import React from 'react';

// This is a stateless function, it doesnt extends React.Component
// cause it doesn't have any other functionality than to just show some HTML.

const NotFound = (props) => {
    return (
        <h2>Not Found!111!!</h2>
    )
}

export default NotFound;



/** WEBPACK FOOTER **
 ** ./src/components/NotFound.js
 **/